module.exports = __webpack_public_path__ + "images/Mid Rectangle.svg";